import React from 'react'
import Covid from '../covid/Covid'
import Footer from '../footer/Footer'
import NavigationBar from '../nav/NavigationBar'
function CovidPage() {
  return (
    <div>
      <NavigationBar />
      <Covid />
      <Footer />
    </div>
  )
}

export default CovidPage